import {
  FieldValues,
  Resolver,
  useForm as useFormHook,
  UseFormProps,
  UseFormReturn,
} from 'react-hook-form'
import { yupResolver } from '@hookform/resolvers/yup'

type UseYupFormProps<T extends FieldValues> = UseFormProps<T> & {
  schema: Parameters<typeof yupResolver>[0]
}

export function useForm<T extends FieldValues>(props: UseYupFormProps<T>): UseFormReturn<T> {
  const { schema, ...formProps } = props

  return useFormHook<T>({
    ...formProps,
    resolver: yupResolver(schema) as Resolver<T>,
  })
}
